import { onMounted, onUnmounted, ref } from 'vue'

/**
 * Tracks the user's scroll direction and elevation to drive the shared header UX.
 * - isSticky: becomes true once the page has been scrolled past the hero.
 * - isHidden: true while the user scrolls down to free vertical space.
 * - isTransparent: true only at the top of the page so the header can be ghosted.
 */
export const useHeaderScroll = () => {
  const isSticky = ref(false)
  const isHidden = ref(false)
  const isTransparent = ref(true)

  let lastScrollY = 0
  let ticking = false

  const handleScroll = () => {
    const currentScroll = window.scrollY
    isSticky.value = currentScroll > 50
    isTransparent.value = currentScroll <= 40

    if (!ticking) {
      window.requestAnimationFrame(() => {
        isHidden.value = currentScroll > lastScrollY && currentScroll > 120
        lastScrollY = Math.max(currentScroll, 0)
        ticking = false
      })
      ticking = true
    }
  }

  onMounted(() => {
    lastScrollY = window.scrollY
    window.addEventListener('scroll', handleScroll, { passive: true })
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
  })

  return {
    isSticky,
    isHidden,
    isTransparent,
  }
}
